import { useFormFields, useMailChimpForm } from "use-mailchimp-form";
import blackLogo from "../../../../assets/images/black-logo.svg";
import { useEffect } from "react";
import styled from "@emotion/styled";

const Section = styled.section`
    background-color: #010035;
    padding: 80px 20px;
    display: flex;
    flex-direction: column;
`;

const FormContainer = styled.div`
    width: 100%;
    max-width: 840px;
    margin: -250px auto 0;
    padding: 50px 20px;
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
`;

const ContentWrapper = styled.div`
    max-width: 620px;
    margin: 0 auto;
`;

const Logo = styled.div`
    margin-bottom: 40px;
    img {
        height: 32px;
    }
`;

const Title = styled.h2`
    font-family: "Gilroy-SemiBold", sans-serif;
    font-size: 22px;
    color: #010035;
    margin-bottom: 16px;
`;

const Subtitle = styled.h4`
    font-family: "Gilroy", sans-serif;
    font-size: 16px;
    line-height: 1.5;
    color: #000;
    margin-bottom: 40px;
    font-weight: 500;
`;

const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-bottom: 24px;
`;

const InputGroup = styled.div`
    display: flex;
    gap: 16px;

    @media (max-width: 576px) {
        flex-direction: column;
    }
`;

const Input = styled.input`
    flex: 1;
    padding: 16px;
    border: none;
    border-bottom: 1px solid #e7e5e5;
    font-family: "Gilroy", sans-serif;
    font-size: 16px;
    color: #010035;

    &::placeholder {
        color: #7c7c7c;
    }

    &:focus {
        outline: none;
        border-color: #010035;
    }
`;

const SubmitButton = styled.button`
    align-self: center;
    padding: 16px 48px;
    margin-left: auto;
    background: #010035;
    color: white;
    border: none;
    border-radius: 100px;
    font-family: "Gilroy-SemiBold", sans-serif;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        background: #01002b;
    }
`;

const Message = styled.div`
    font-family: "Gilroy", sans-serif;
    font-size: 14px;

    &.error {
        color: #ff4d4f;
    }

    &.success {
        color: #52c41a;
    }

    &.loading {
        color: #7c7c7c;
    }
`;

const FeaturesGrid = styled.div`
    max-width: 1280px;
    padding-left: 20px;
    padding-right: 20px;
    margin: 80px auto 0;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 32px;

    @media (max-width: 992px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 576px) {
        grid-template-columns: 1fr;
    }
`;

const FeatureItem = styled.div`
    color: white;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 18px;
    border-right: 1px solid #e7e5e5;
    height: 100%;
    padding-right: 20px;

    &:last-child {
        padding-right: 0;
        border-right: none;
    }

    @media (max-width: 992px) {
        &:nth-child(2n) {
            border-right: none;
        }
    }


    @media (max-width: 576px) {
        border-right: none;
        border-bottom: 1px solid rgba(255, 255, 255, 0.3);
        padding-top: 20px;
        padding-bottom: 38px;

        &:last-child {
            border-bottom: none;
        }
    }
`;

const FeatureIcon = styled.div`
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        width: 100%;
        height: 100%;
        fill: #ffa800;
    }
`;

const FeatureText = styled.p`
    font-family: "Gilroy", sans-serif;
    font-size: 16px;
    line-height: 1.5;
    color: white;
    margin: 0;
    height: 100%;
    text-align: left;
`;

const SubscribeSection = ({ closeForm }) => {
    const postUrl = `https://pivothawk.us19.list-manage.com/subscribe/post?u=07f7ac1a10dc5a24e04db56f6&amp;id=4e388138f3&amp;f_id=007689e3f0`;
    const { loading, error, success, message, handleSubmit } =
        useMailChimpForm(postUrl);
    const { fields, handleFieldChange } = useFormFields({
        EMAIL: "",
        MERGE1: "",
    });

    useEffect(() => {
        if (success) {
            setTimeout(() => {
                closeForm(true);
            }, 5000);
        }
    }, [success]);

    return (
        <Section>
            <FormContainer>
                <ContentWrapper>

                   <div id="subscribe">
                    <Title>
                        Want to be the first to know when PivotHawk is
                        available?
                    </Title>
                   </div>
                    <Subtitle>
                        We're working hard to bring you the smartest, most
                        affordable pivot irrigation monitoring solution.
                        <br />
                        <br />
                        Subscribe now for updates on launch dates, exclusive
                        early-bird offers, and special discounts! Be part of the
                        next revolution in smart irrigation.
                    </Subtitle>

                    <Form
                        onSubmit={(event) => {
                            event.preventDefault();
                            handleSubmit(fields);
                        }}
                    >
                        <InputGroup>
                            <Input
                                id="MERGE1"
                                placeholder="Name"
                                type="text"
                                value={fields.MERGE1}
                                onChange={handleFieldChange}
                            />
                            <Input
                                id="EMAIL"
                                placeholder="Email"
                                type="email"
                                value={fields.EMAIL}
                                onChange={handleFieldChange}
                            />
                        </InputGroup>
                        <SubmitButton type="submit">Subscribe</SubmitButton>
                    </Form>

                    <Message
                        className={
                            loading
                                ? "loading"
                                : error
                                  ? "error"
                                  : success
                                    ? "success"
                                    : ""
                        }
                    >
                        {loading && "Submitting..."}
                        {error &&
                            (message === "0 - Please enter a value"
                                ? "Please enter your email address"
                                : message)}
                        {success && message}
                    </Message>
                </ContentWrapper>
            </FormContainer>

            <FeaturesGrid>
                <FeatureItem>
                    <FeatureIcon>
                        <svg
                            width="36"
                            height="36"
                            viewBox="0 0 36 36"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M19.125 12.5999C19.125 11.9786 18.6213 11.4749 18 11.4749C17.3786 11.4749 16.875 11.9786 16.875 12.5999L16.875 19.125H10.125C9.50368 19.125 9 19.6287 9 20.25C9 20.8713 9.50368 21.375 10.125 21.375H18C18.2984 21.375 18.5845 21.2565 18.7955 21.0455C19.0065 20.8345 19.125 20.5484 19.125 20.25L19.125 12.5999Z"
                                fill="#FFA800"
                            />
                            <path
                                d="M14.625 2.25C14.625 1.62868 15.1287 1.125 15.75 1.125H20.25C20.8713 1.125 21.375 1.62868 21.375 2.25C21.375 2.87132 20.8713 3.375 20.25 3.375V4.65962C23.3097 5.09745 26.0856 6.41436 28.3136 8.34631C28.3227 8.33657 28.332 8.32695 28.3415 8.31745L29.137 7.52196L28.3415 6.72646C27.9021 6.28712 27.9021 5.57481 28.3415 5.13547C28.7808 4.69613 29.4931 4.69613 29.9325 5.13547L33.1145 8.31745C33.5538 8.75679 33.5538 9.4691 33.1145 9.90845C32.6751 10.3478 31.9628 10.3478 31.5235 9.90845L30.728 9.11295L29.9325 9.90845C29.923 9.91792 29.9134 9.92718 29.9037 9.93625C32.2999 12.6994 33.75 16.3052 33.75 20.25C33.75 28.9485 26.6985 36 18 36C9.30151 36 2.25 28.9485 2.25 20.25C2.25 12.3153 8.11685 5.75188 15.75 4.65962V3.375C15.1287 3.375 14.625 2.87132 14.625 2.25ZM18 6.75C17.65 6.75 17.3033 6.7633 16.9603 6.78938C9.99086 7.31956 4.5 13.1441 4.5 20.25C4.5 27.7058 10.5442 33.75 18 33.75C25.4558 33.75 31.5 27.7058 31.5 20.25C31.5 13.1441 26.0091 7.31956 19.0397 6.78938C18.6967 6.7633 18.35 6.75 18 6.75Z"
                                fill="#FFA800"
                            />
                        </svg>
                    </FeatureIcon>
                    <FeatureText>
                        Know exactly when your pivot is running or stopped – no
                        more wasted trips to the field.
                    </FeatureText>
                </FeatureItem>

                <FeatureItem>
                    <FeatureIcon>
                        <svg
                            width="40"
                            height="40"
                            viewBox="0 0 40 40"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M12.5001 15.625C12.5001 16.6605 11.6607 17.5 10.6251 17.5C9.58961 17.5 8.75014 16.6605 8.75014 15.625C8.75014 14.5895 9.58961 13.75 10.6251 13.75C11.6607 13.75 12.5001 14.5895 12.5001 15.625Z"
                                fill="#FFA800"
                            />
                            <path
                                d="M15.3454 11.8839C16.7722 11.4739 18.308 11.25 19.9108 11.25C21.5758 11.25 23.1685 11.4916 24.6419 11.9325C25.3032 12.1304 25.9998 11.7546 26.1977 11.0933C26.3956 10.4319 26.0199 9.73529 25.3585 9.53739C23.6518 9.02671 21.8176 8.75 19.9108 8.75C18.0752 8.75 16.307 9.00642 14.655 9.48111C13.9915 9.67177 13.6081 10.3642 13.7988 11.0277C13.9894 11.6912 14.6819 12.0745 15.3454 11.8839Z"
                                fill="#FFA800"
                            />
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M19.911 3.81836C12.467 3.81836 5.98202 8.07759 4.10908 14.1309H2.73651C1.18452 14.1309 0.00755845 15.5302 0.273477 17.0592L0.908551 20.7109C1.22093 22.5071 2.77993 23.8184 4.6031 23.8184H5.25992C6.00832 25.1008 6.9797 26.2633 8.1238 27.2729L6.30121 33.4654C6.18997 33.8434 6.26343 34.2517 6.49944 34.5671C6.73544 34.8826 7.10637 35.0684 7.50035 35.0684H12.5004C13.0289 35.0684 13.5003 34.736 13.6778 34.2381L14.8824 30.8593C16.469 31.2932 18.1594 31.5267 19.911 31.5267C21.6772 31.5267 23.3811 31.2893 24.9792 30.8484L26.3382 34.2788C26.527 34.7554 26.9877 35.0684 27.5004 35.0684H32.5004C32.8963 35.0684 33.2688 34.8808 33.5046 34.5627C33.7403 34.2446 33.8115 33.8337 33.6963 33.4549L31.792 27.1894C34.525 24.7365 36.2502 21.3968 36.2502 17.6725C36.2502 17.309 36.2341 16.9494 36.2024 16.5942C36.8537 16.3194 37.4698 15.9299 37.9627 15.4844C38.7502 16.25 40.0002 16.25 40.0002 14.4435C40.0002 15 38.7502 15 38.8472 14.3768C38.9513 14.1734 39.0294 13.9601 39.0712 13.7396C39.1797 13.1675 39.0319 12.5913 38.5671 12.1265C38.0252 11.5847 37.3221 11.5986 36.8005 11.8831C36.3093 12.151 35.9236 12.6778 35.8626 13.2876C35.8019 13.8943 36.0686 14.4884 36.663 14.9218C36.4604 15.0623 36.2424 15.1915 36.0162 15.3045C34.681 8.6448 27.806 3.81836 19.911 3.81836ZM6.2914 15.6493C7.4271 10.4847 12.958 6.31836 19.911 6.31836C27.7743 6.31836 33.7502 11.603 33.7502 17.6725C33.7502 20.8087 32.1904 23.6963 29.5756 25.7924C29.1768 26.1121 29.0128 26.6423 29.1614 27.1313L30.814 32.5684H28.3497L26.8767 28.8503C26.6299 28.2275 25.936 27.9099 25.3034 28.1303C23.6498 28.7063 21.8284 29.0267 19.911 29.0267C17.9936 29.0267 16.1722 28.7063 14.5186 28.1303C13.8701 27.9043 13.1607 28.244 12.93 28.8909L11.6189 32.5684H9.17127L10.7536 27.1921C10.8978 26.7022 10.7295 26.1739 10.3285 25.8577C8.94539 24.767 7.85006 23.4539 7.11811 22.0048C6.90547 21.5838 6.47399 21.3184 6.00236 21.3184H4.6031C3.99537 21.3184 3.47571 20.8813 3.37158 20.2825L2.73651 16.6309H5.07057C5.65748 16.6309 6.16535 16.2225 6.2914 15.6493ZM37.8431 13.5067C37.815 13.655 37.7362 13.8344 37.5972 14.033C37.5577 14.0124 37.521 13.9915 37.487 13.9705C37.1238 13.746 37.0944 13.5324 37.1064 13.4119C37.1236 13.2405 37.2457 13.0641 37.399 12.9805C37.522 12.9134 37.6001 12.9273 37.6832 13.0104C37.8434 13.1706 37.8778 13.3237 37.8431 13.5067Z"
                                fill="#FFA800"
                            />
                        </svg>
                    </FeatureIcon>
                    <FeatureText>
                        Save time, fuel, and water with instant alerts and smart
                        insights.
                    </FeatureText>
                </FeatureItem>

                <FeatureItem>
                    <FeatureIcon>
                        <svg
                            width="36"
                            height="36"
                            viewBox="0 0 36 36"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M16.2206 1.80074C17.3008 0.662651 18 0 18 0C18.245 0.816571 18.5255 1.59386 18.8351 2.33612C20.6612 6.71344 23.4996 9.87252 26.0268 12.6853C28.9752 15.9667 31.5 18.7768 31.5 22.5C31.5 29.9558 25.4558 36 18 36C10.5442 36 4.5 29.9558 4.5 22.5C4.5 15.003 12.5545 5.66345 16.2206 1.80074ZM17.1526 4.09788C15.9761 5.37331 14.5043 7.05941 13.0371 8.9774C11.402 11.1148 9.80606 13.4966 8.62702 15.8855C7.43581 18.2991 6.75 20.5607 6.75 22.5C6.75 22.5 12.375 25.875 18 23.625C23.625 21.375 29.25 22.5 29.25 22.5C29.25 19.7972 27.4596 17.6465 24.342 14.1766L24.2756 14.1027C21.9349 11.4978 19.1239 8.3694 17.1526 4.09788Z"
                                fill="#FFA800"
                            />
                            <path
                                d="M10.2438 17.4969C12.0905 13.8035 14.1081 11.3009 14.9545 10.4545L16.5455 12.0455C15.8919 12.6991 14.0095 14.9965 12.2562 18.5031L10.2438 17.4969Z"
                                fill="#FFA800"
                            />
                        </svg>
                    </FeatureIcon>
                    <FeatureText>
                        Easy plug & play installation – no complicated setup
                        required.
                    </FeatureText>
                </FeatureItem>

                <FeatureItem>
                    <FeatureIcon>
                        <svg
                            width="36"
                            height="36"
                            viewBox="0 0 36 36"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M11.25 0C11.8713 0 12.375 0.50368 12.375 1.125V4.5H14.625V1.125C14.625 0.50368 15.1287 0 15.75 0C16.3713 0 16.875 0.50368 16.875 1.125V4.5H19.125V1.125C19.125 0.50368 19.6287 0 20.25 0C20.8713 0 21.375 0.50368 21.375 1.125V4.5H23.625V1.125C23.625 0.50368 24.1287 0 24.75 0C25.3713 0 25.875 0.50368 25.875 1.125V4.5C28.9816 4.5 31.5 7.0184 31.5 10.125H34.875C35.4963 10.125 36 10.6287 36 11.25C36 11.8713 35.4963 12.375 34.875 12.375H31.5V14.625H34.875C35.4963 14.625 36 15.1287 36 15.75C36 16.3713 35.4963 16.875 34.875 16.875H31.5V19.125H34.875C35.4963 19.125 36 19.6287 36 20.25C36 20.8713 35.4963 21.375 34.875 21.375H31.5V23.625H34.875C35.4963 23.625 36 24.1287 36 24.75C36 25.3713 35.4963 25.875 34.875 25.875H31.5C31.5 28.9816 28.9816 31.5 25.875 31.5V34.875C25.875 35.4963 25.3713 36 24.75 36C24.1287 36 23.625 35.4963 23.625 34.875V31.5H21.375V34.875C21.375 35.4963 20.8713 36 20.25 36C19.6287 36 19.125 35.4963 19.125 34.875V31.5H16.875V34.875C16.875 35.4963 16.3713 36 15.75 36C15.1287 36 14.625 35.4963 14.625 34.875V31.5H12.375V34.875C12.375 35.4963 11.8713 36 11.25 36C10.6287 36 10.125 35.4963 10.125 34.875V31.5C7.0184 31.5 4.5 28.9816 4.5 25.875H1.125C0.50368 25.875 0 25.3713 0 24.75C0 24.1287 0.50368 23.625 1.125 23.625H4.5V21.375H1.125C0.50368 21.375 0 20.8713 0 20.25C0 19.6287 0.50368 19.125 1.125 19.125H4.5V16.875H1.125C0.50368 16.875 0 16.3713 0 15.75C0 15.1287 0.50368 14.625 1.125 14.625H4.5V12.375H1.125C0.50368 12.375 0 11.8713 0 11.25C0 10.6287 0.50368 10.125 1.125 10.125H4.5C4.5 7.0184 7.0184 4.5 10.125 4.5V1.125C10.125 0.50368 10.6287 0 11.25 0ZM10.125 6.75C8.26104 6.75 6.75 8.26104 6.75 10.125V25.875C6.75 27.739 8.26104 29.25 10.125 29.25H25.875C27.739 29.25 29.25 27.739 29.25 25.875V10.125C29.25 8.26104 27.739 6.75 25.875 6.75H10.125ZM11.25 14.625C11.25 12.761 12.761 11.25 14.625 11.25H21.375C23.239 11.25 24.75 12.761 24.75 14.625V21.375C24.75 23.239 23.239 24.75 21.375 24.75H14.625C12.761 24.75 11.25 23.239 11.25 21.375V14.625ZM14.625 13.5C14.0037 13.5 13.5 14.0037 13.5 14.625V21.375C13.5 21.9963 14.0037 22.5 14.625 22.5H21.375C21.9963 22.5 22.5 21.9963 22.5 21.375V14.625C22.5 14.0037 21.9963 13.5 21.375 13.5H14.625Z"
                                fill="#FFA800"
                            />
                        </svg>
                    </FeatureIcon>
                    <FeatureText>
                        Works with any pivot system, future-ready for expansion
                        with sensors & AI features.
                    </FeatureText>
                </FeatureItem>
            </FeaturesGrid>
        </Section>
    );
};

export default SubscribeSection;
